module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC3SURBVHgBzdTRDYMgEAbgOx+Yw1UKg9iO0AnEDTqCnYIXCOkkHYUejU2MEcKBafxf0Hh+HAkAcIYYY/rUtw6YsdYOQoi3935oBp1zIyLO8TmEcNmrQShMxGjQ358Qn1LKK9R2uMYoUwor6nCLKaV0rh6PxLJgDZYEa7GYrmCiAIzklqxpGJdXTV1O0ALWoiXbRnPQopPCQTlHT6/QB6H3JnAHnQm9bWtYt82yH3/IC44K3YU9/CsfwxFQtyfEEMkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanclub/arrow_gray.png
// module id = gyK8
// module chunks = 7